import { createContext } from 'react';
export var ToasterSystemContext = createContext({
  removeToast: function removeToast() {},
  addToast: function addToast() {},
  toastGroup: []
});